import { QDialog, QBtn } from "quasar";
import { defineComponent, defineAsyncComponent, ref, computed, watch, onBeforeMount, createElementBlock, openBlock, Fragment, createBlock, createCommentVNode, createVNode, withCtx } from "vue";
import { registerEntityEndpoint, CardList } from "@editor/ui-utils";
import { useI18n } from "vue-i18n";
const de = {
  apiTeaserList: {
    search: "Nach Placement ID suchen",
    brand: "Marke",
    isEnabled: "Aktiviert",
    externalId: "Placement ID",
    headerExternalId: "Placement IDs",
    headerChangedAt: "Geändert am",
    select: "API Teaser auswählen"
  }
};
const en = {
  apiTeaserList: {
    search: "Search by Placement ID",
    brand: "Brand",
    isEnabled: "Enabled",
    externalId: "Placement ID",
    headerExternalId: "Placement IDs",
    headerChangedAt: "Changed at",
    select: "Select API Teaser"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/api-teaser",
    children: [
      {
        path: "",
        name: "api_teaser_list",
        component: () => import("./api-teaser-list.view-UKvLtRuo.js"),
        meta: { requiredRight: "navigate_list_api_teaser" }
      }
    ]
  }
];
const entityEndpoint = "api-teaser";
const ApiTeaserService = registerEntityEndpoint(entityEndpoint);
const { getEntity, listEntities } = ApiTeaserService;
const getApiTeaser = async (id) => {
  return getEntity(id);
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "api-teaser-list.selector",
  props: {
    modelValue: { type: String, required: false, default: "" },
    brand: { type: String, required: false, default: void 0 },
    disableBrand: { type: Boolean, required: false, default: false },
    disable: { type: Boolean, required: false, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const ApiTeaserList = defineAsyncComponent(() => import("./api-teaser-list.view-UKvLtRuo.js"));
    const props = __props;
    const emit = __emit;
    const { t } = useI18n();
    const dialogVisible = ref(false);
    const apiTeaserData = ref();
    const apiTeaserPreview = computed(() => {
      var _a, _b;
      return [
        {
          _id: ((_a = apiTeaserData.value) == null ? void 0 : _a._id) ?? "",
          title: ((_b = apiTeaserData.value) == null ? void 0 : _b.externalId) ?? ""
        }
      ];
    });
    const handleClick = (clickedTeaser) => {
      var _a;
      apiTeaserData.value = clickedTeaser;
      emit("update:modelValue", (_a = apiTeaserData.value) == null ? void 0 : _a._id);
      dialogVisible.value = false;
    };
    const handleRemove = () => {
      apiTeaserData.value = void 0;
      emit("update:modelValue", void 0);
    };
    watch(
      () => props.modelValue,
      async () => {
        if (props.modelValue) {
          apiTeaserData.value = await getApiTeaser(props.modelValue);
        } else {
          apiTeaserData.value = void 0;
        }
      }
    );
    onBeforeMount(async () => {
      apiTeaserData.value = await getApiTeaser(props.modelValue);
    });
    const __returned__ = { ApiTeaserList, props, emit, t, dialogVisible, apiTeaserData, apiTeaserPreview, handleClick, handleRemove, get CardList() {
      return CardList;
    }, get QBtn() {
      return QBtn;
    }, get QDialog() {
      return QDialog;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  return openBlock(), createElementBlock(
    Fragment,
    null,
    [
      !((_a = $setup.apiTeaserData) == null ? void 0 : _a._id) ? (openBlock(), createBlock($setup["QBtn"], {
        key: 0,
        "text-color": "secondary",
        icon: "plus",
        color: "primary",
        class: "q-mr-sm bg-white",
        "data-qa": "api-teaser-select-button",
        label: $setup.t("apiTeaserList.select"),
        outline: "",
        disable: $props.disable,
        onClick: _cache[0] || (_cache[0] = ($event) => $setup.dialogVisible = true)
      }, null, 8, ["label", "disable"])) : createCommentVNode("v-if", true),
      ((_b = $setup.apiTeaserData) == null ? void 0 : _b._id) ? (openBlock(), createBlock($setup["CardList"], {
        key: 1,
        items: $setup.apiTeaserPreview,
        disable: $props.disable,
        onRemoveItem: $setup.handleRemove
      }, null, 8, ["items", "disable"])) : createCommentVNode("v-if", true),
      createVNode($setup["QDialog"], {
        "model-value": $setup.dialogVisible,
        "full-width": "",
        "full-height": "",
        onHide: _cache[3] || (_cache[3] = ($event) => $setup.dialogVisible = false)
      }, {
        default: withCtx(() => [
          createVNode($setup["ApiTeaserList"], {
            brand: $props.brand,
            "disable-brand": $props.disableBrand,
            dialog: true,
            selection: "none",
            "onClick:apiTeaser": $setup.handleClick,
            onClose: _cache[1] || (_cache[1] = ($event) => $setup.dialogVisible = false),
            "onBack:modal": _cache[2] || (_cache[2] = ($event) => $setup.dialogVisible = false)
          }, null, 8, ["brand", "disable-brand"])
        ]),
        _: 1
        /* STABLE */
      }, 8, ["model-value"])
    ],
    64
    /* STABLE_FRAGMENT */
  );
}
const apiTeaserList_selector = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/builds/CT/content-technology-framework/modules/api-teaser/editor-ui/src/selectors/api-teaser-list.selector.vue"]]);
const apiTeaserModule = {
  messages,
  routes
};
export {
  ApiTeaserService as A,
  _export_sfc as _,
  apiTeaserModule as a,
  apiTeaserList_selector as b
};
//# sourceMappingURL=index-hDCACtoa.js.map
